import React, { ReactNode } from "react";
import ZomentumLogo from "../../../Assets/PaymentsAppHeader/ZomentumLogo.svg";
import { PaymentRoutes } from "../../../Contracts/Routes";

interface EmptyHeaderLayoutProps {
  children: ReactNode;
}

const EmptyHeaderLayout: React.FC<EmptyHeaderLayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col h-screen shadow-lg">
      <nav className="sticky header h-16 flex z-30">
        <div className="flex flex-grow items-center justify-between">
          <a href={PaymentRoutes.GETTING_STARTED} className="flex items-center justify-center ml-4">
            <img src={ZomentumLogo} alt="Zomentum" className="h-5" />
          </a>
        </div>
      </nav>
      <div className="flex flex-grow bg-white-smoke">
        <div className="bg-white m-4 p-6 rounded flex-grow shadow-md">{children}</div>
      </div>
    </div>
  );
};

export default EmptyHeaderLayout;
